import { axiosInstance } from 'shared/config/axios';
import { endImpersonation, isImpersonationMode } from 'shared/helpers/impersonation';

export const signOut = async () => {
	// localStorage.clear() below would wipe the admin's own session shared
	// across tabs; the impersonation tab only owns its sessionStorage
	if (isImpersonationMode()) {
		endImpersonation();
		return;
	}

	try {
		await axiosInstance.post('/auth/sign-out');
	} catch {
		// proceed with local logout even if the server call fails
	} finally {
		localStorage.clear();
		sessionStorage.clear();
		window.location.replace('/sign-in');
	}
};
